'use strict';

angular.module('ClinicApp').factory('ProviderService', function($q, ProviderResource, ProviderOfferedAppointmentTypeResource, ProviderOfferedServiceResource, ClinicDoctorsResource, ProviderConfirmRelationshipResource) {
  return {
    addOfferedAppointmentType: function(providerId, appointmentTypeId, duration, price) {
      if (!appointmentTypeId || !duration) {
        return $q.reject('ProviderService.addOfferedAppointmentType: appointmentTypeId and duration are required.');
      }
      var _this = this;
      var offeredAppointmentType = {
        appointmentTypeId: appointmentTypeId,
        duration: duration,
        price: price,
      };
      return ProviderOfferedAppointmentTypeResource.save({
        id: providerId,
      }, offeredAppointmentType).$promise.then(function() {
        return _this.getProvider(providerId);
      }).then(function(provider) {
        return provider.offeredAppointmentTypes;
      });
    },

    addOfferedService: function(providerId, serviceId) {
      if (!serviceId) {
        return $q.reject('ProviderService.addOfferedService: serviceId is required.');
      }
      return ProviderOfferedServiceResource.save({
        id: providerId,
      }, {
        serviceId: serviceId,
      }).$promise;
    },

    removeOfferedService: function(providerId, offeredServiceId) {
      return ProviderOfferedServiceResource.remove({
        id: providerId,
        offeredServiceId: offeredServiceId,
      }).$promise;
    },

    confirmProviderRelationship: function(providerId, doctorId) {
      return ProviderConfirmRelationshipResource.save({
        providerId: providerId,
        id: doctorId,
      }, null).$promise;
    },

    createProvider: function(clinicId, doctorId) {
      return ClinicDoctorsResource.save({
        id: clinicId,
        doctorId: doctorId,
      }, null).$promise;
    },

    getProvider: function(providerId) {
      return ProviderResource.get({
        id: providerId,
      }).$promise;
    },

    removeOfferedAppointmentType: function(providerId, offeredAppointmentTypeId) {
      var _this = this;
      return ProviderOfferedAppointmentTypeResource.remove({
        id: providerId,
        offeredAppointmentTypeId: offeredAppointmentTypeId,
      }).$promise.then(function() {
        return _this.getProvider(providerId);
      }).then(function(provider) {
        return provider.offeredAppointmentTypes;
      });
    },

    removeProvider: function(providerId) {
      return ProviderResource.remove({
        id: providerId,
      }).$promise;
    },

    updateProvider: function(providerId, data) {
      if (!data || angular.equals({}, data)) {
        return $q.when();
      }
      return ProviderResource.update({
        id: providerId,
      }, data).$promise;
    },
  };
});
